import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["newExerciseId", "exerciseId", "sets"]

  connect() {
    this.container = this.element
  }

  remove(event) {
    const element = event.currentTarget.closest(".removable")
    element.remove()
    event.preventDefault()
  }

  moveUp(event) {
    event.preventDefault()
    const elements = this.container.getElementsByClassName("removable")
    const element = event.currentTarget.closest(".removable")
    const index = Array.from(elements).indexOf(element)
    const otherElement = elements[index - 1]
    if (otherElement !== undefined) {
      element.parentNode.insertBefore(element, otherElement)
      this.reindex()
    }
  }

  moveDown(event) {
    event.preventDefault()
    const elements = this.container.getElementsByClassName("removable")
    const element = event.currentTarget.closest(".removable")
    const index = Array.from(elements).indexOf(element)
    const otherElement = elements[index + 1]
    if (otherElement !== undefined) {
      element.parentNode.insertBefore(otherElement, element)
      this.reindex()
    }
  }

  exerciseIdTargetConnected() {
    this.reindex()
  }
  
  exerciseIdTargetDisconnected() {
    this.reindex()
  }

  reindex() {
    this.reindexExerciseIds()
    this.reindexSets()
  }
  
  reindexExerciseIds() {
    let index = 0
    for (let exerciseIdTarget of this.exerciseIdTargets) {
      exerciseIdTarget.name = `training_program[program_exercises_attributes][${index++}][exercise_id]`
    }
  }

  reindexSets() {
    let index = 0
    for (let setsTarget of this.setsTargets) {
      setsTarget.name = `training_program[program_exercises_attributes][${index++}][sets]`
    }
  }

  add() {
    const id = this.newExerciseId.value

    post("/traing/program_exercises", {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      },
      body: {
        training_program_exercise: {
          exercise_id: id
        }
      }
    })
  }
}